import { Dispatch, SetStateAction } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { StackLayout } from '@progress/kendo-react-layout'
import { useAppSelector } from '../../../stores'
import { GetSupplierHearingReplyItemSummaryRes } from '@gateway.Supplier'
import { useNavigate } from 'react-router-dom'
import { ErrorMessage } from '../../../components/parts'
import { MessageProvider } from '../../../services'
import { forwardGuard } from '../../../components/hooks'

export interface ConfirmReplyFooterProps {
  handleOnId: Dispatch<SetStateAction<string>>
  handleOnArgslist: Dispatch<SetStateAction<string[]>>
  handleOnMessageKey: Dispatch<SetStateAction<string>>
  handleOnConfirmDialogshow: Dispatch<SetStateAction<boolean>>
  setNotificationMessages: React.Dispatch<React.SetStateAction<ErrorMessage[]>>
  setErrorMessages: React.Dispatch<React.SetStateAction<ErrorMessage[]>>
  supplierHearing:
  | GetSupplierHearingReplyItemSummaryRes['supplierHearing']
  | undefined
  lastMonthFlg: boolean
  isNotOwnBranch: boolean
  isChanged: boolean
}

export default function ConfirmReplyFooter(props: ConfirmReplyFooterProps) {
  const { hearingSheetFlg } = useAppSelector(
    (state) => state.confirmreply.confirmReplyInfo
  )
  const userProp = useAppSelector((state) => state.common.userProp)
  const navigate = useNavigate()

  /** 戻る */
  const handleGoBack = () => {
    navigate(-1)
  }

  /** グラフ */
  const handleStatistics = () => {
    forwardGuard('内容が編集中です。このページを離れますか？', navigate, '/supplier/reply-aggregation-graph', props.isChanged)
  }

  /** 修正依頼 */
  const correctionRequest = () => {
    if (props.supplierHearing?.attachmentFilePath === '') {
      props.handleOnId('I009')
    } else {
      props.handleOnId('I007')
      props.handleOnArgslist(['修正依頼'])
    }
    props.handleOnMessageKey('修正依頼')
    props.handleOnConfirmDialogshow(true)
  }

  /** 回答送信 */
  const answerTransmission = () => {
    if (
      props.supplierHearing?.addStsCdSupplierDecisionBuilding === '3' &&
      props.supplierHearing?.addStsCdSupplierEstimationBuilding === '3' &&
      props.supplierHearing?.addStsCdOtherCompanyBuilding === '3' &&
      props.supplierHearing?.addStsCdSupplierMaxCapacity === '3' &&
      ((props.supplierHearing?.addStsCdHearingSheet === '3' && hearingSheetFlg === 1) || hearingSheetFlg === 0)
    ) {
      props.handleOnId('I010')
      props.handleOnMessageKey('回答送信')
      props.handleOnConfirmDialogshow(true)
    } else {
      const checkMessage: string[] = []
      if (props.supplierHearing?.addStsCdSupplierDecisionBuilding !== '3') {
        checkMessage.push('業者決定物件')
      }
      if (props.supplierHearing?.addStsCdSupplierEstimationBuilding !== '3') {
        checkMessage.push('見積中物件')
      }
      if (props.supplierHearing?.addStsCdOtherCompanyBuilding !== '3') {
        checkMessage.push('他社物件')
      }
      if (props.supplierHearing?.addStsCdSupplierMaxCapacity !== '3') {
        checkMessage.push('業者最大能力')
      }
      if (props.supplierHearing?.addStsCdHearingSheet !== '3' && hearingSheetFlg === 1) {
        checkMessage.push('ヒアリングシート')
      }
      const message: ErrorMessage[] = [{
        id: 'E017',
        content: MessageProvider.provide(
          'E017', checkMessage.join(',')
        )
      }]
      props.setErrorMessages(message)
    }
  }

  /** 回答確認 */
  const answerConfirmation = () => {
    props.handleOnId('I008')
    props.handleOnMessageKey('回答確認')
    props.handleOnArgslist(['確認済'])
    props.handleOnConfirmDialogshow(true)
  }

  /** 取戻 */
  const handleRefund = () => {
    props.handleOnId('I008')
    props.handleOnMessageKey('取戻')
    props.handleOnArgslist(['回答済'])
    props.handleOnConfirmDialogshow(true)
  }

  return (
    <div
      className="pcy-search-body-pane-footer pcy-control-box"
      style={{
        backgroundColor: '#FFFFFF'
      }}
    >
      <StackLayout>
        {/* 回答送信ボタンを ConfirmReplyHeader に移動したが、
            今後、元に戻すことも考慮して非表示のままコードは残しておくこととする */}
        <div style={{ display: 'none' }}>
          <StackLayout gap={5} align={{ horizontal: 'start' }}>
            {(props.supplierHearing?.replyStsCd === '2' ||
              props.supplierHearing?.replyStsCd === '3' ||
              props.supplierHearing?.replyStsCd === '4' ||
              props.supplierHearing?.replyStsCd === '6') &&
              !props.lastMonthFlg &&
              !props.isNotOwnBranch
              ? (
                <Button onClick={answerTransmission} themeColor="primary">
                  回答送信
                </Button>
                )
              : null}
          </StackLayout>
        </div>
        <StackLayout gap={5} align={{ horizontal: 'end' }}>
          <Button onClick={handleGoBack}>戻る</Button>
          <Button onClick={handleStatistics}>グラフ</Button>

          {props.supplierHearing?.replyStsCd !== '5' ||
          userProp?.authority === 5 ||
          props.lastMonthFlg ||
          props.isNotOwnBranch
            ? null
            : (
            <>
              <Button
                onClick={correctionRequest}
                themeColor="primary"
              >
                修正依頼
              </Button>
              <Button
                onClick={answerConfirmation}
                themeColor="primary"
              >
                回答確認
              </Button>
            </>
              )}

          {props.supplierHearing?.replyStsCd !== '7' ||
          userProp?.authority === 5 ||
          props.lastMonthFlg ||
          props.isNotOwnBranch
            ? null
            : (
            <Button
              onClick={handleRefund}
              themeColor="primary"
            >
              取戻
            </Button>
              )}
        </StackLayout>
      </StackLayout>
    </div>
  )
}
